var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#CCD2E3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2405 10.4398C14.8991 8.85338 17.1009 8.85338 17.7595 10.4398L18.2183 11.5449C18.488 12.1946 19.0802 12.645 19.7671 12.7228L21.0472 12.8679C22.664 13.0511 23.3317 15.0816 22.151 16.2241L21.064 17.2759C20.5861 17.7383 20.375 18.4193 20.5051 19.0784L20.7676 20.4069C21.0998 22.0885 19.2982 23.3582 17.8764 22.4445L17.0178 21.8929C16.3957 21.4932 15.6043 21.4932 14.9822 21.8929L14.1236 22.4445C12.7018 23.3582 10.9002 22.0885 11.2324 20.4069L11.4949 19.0784C11.625 18.4193 11.4139 17.7383 10.936 17.2759L9.84903 16.2241C8.66829 15.0816 9.33604 13.0511 10.9528 12.8679L12.2329 12.7228C12.9198 12.645 13.512 12.1946 13.7817 11.5449L14.2405 10.4398Z",
    stroke: "#CCD2E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.b03c85ee.svg";
export { ForwardRef as ReactComponent };